import styled from 'styled-components';
import { Paragraph } from '@mlc/web-ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TrackableAnchor from '../../../common/Anchor/TrackableAnchor';

export const FiltersWrapper = styled.div`
	display: flex;
`;

export const Anchor = styled(TrackableAnchor)`
	align-items: center;
	text-decoration: none;
`;

export const ViewGroupLabel = styled(Paragraph)`
	align-items: center;

	${Anchor}:hover & {
		text-decoration: underline;
	}
`;

export const FilterMenuIcon = styled(FontAwesomeIcon)`
	line-height: 1em;
	margin-right: 7px;
	margin-top: 4px;
`;
